// extracted by mini-css-extract-plugin
export var btnEvent = "Button-module--btnEvent--LARFI";
export var btnSpinner = "Button-module--btnSpinner--8C58Y";
export var btn_spin = "Button-module--btn_spin--eiS3p";
export var outline = "Button-module--outline--IgVUq";
export var primary = "Button-module--primary--LhfXg";
export var secondary = "Button-module--secondary--54jUC";
export var submitBtn = "Button-module--submitBtn--veGXx";
export var tertiary = "Button-module--tertiary--xQPfO";